import Loader from 'components/Kizen/Loader';
import { AREA_RESPONSES } from 'components/Wizards/Dashlet/types';
import { useFilterVariables } from 'ts-components/filters';
import useDynamicFilterObject from '../useDynamicFilterObject';
import { DynamicObjectMetaFilter } from '../DynamicObjectMetaFilter';
import { WizardFilterContext } from 'components/Wizards/MetaFilters/context';

const disallowedResetSelectedObjects = [AREA_RESPONSES.CUSTOM_OBJECT];

const DynamicObjectFilter = ({
  additionalFields,
  area,
  selectedObject,
  filterState,
  customObject,
  onChangeSelectedObject,
  hideWarnings,
  onConfirm,
  isForCustomObject,
  hideGroups,
  hideLLMDecision,
  clientObject,
  defaultCustomFilter,
  intitialRenderRef,
  showDescription,
}) => {
  const { filterProps, onClear, filtersAreEmpty, onFilterConfirm } =
    useDynamicFilterObject({
      isForCustomObject,
      area,
      selectedObject,
      customObject,
      filterState,
      onChangeSelectedObject,
      onConfirm,
      allowResetSelectedObject: !disallowedResetSelectedObjects.includes(area),
      clientObject,
    });

  const { variables, isLoading } = useFilterVariables({
    fieldSettingsSearch: true,
    objectId: customObject?.id,
  });

  if (filterProps.loading || isLoading) {
    return <Loader loading />;
  }

  return (
    <WizardFilterContext
      key={customObject?.id}
      filterProps={filterProps}
      isClient={!isForCustomObject}
      objectId={customObject?.id}
      clientObject={clientObject}
      variables={variables}
    >
      <DynamicObjectMetaFilter
        onClear={onClear}
        filtersAreEmpty={filtersAreEmpty}
        onFilterConfirm={onFilterConfirm}
        additionalFields={additionalFields}
        hideWarnings={hideWarnings}
        hideGroups={hideGroups}
        hideLLMDecision={hideLLMDecision}
        area={area}
        selectedObject={selectedObject}
        defaultCustomFilter={defaultCustomFilter}
        intitialRenderRef={intitialRenderRef}
        showDescription={showDescription}
      />
    </WizardFilterContext>
  );
};

export default DynamicObjectFilter;
